<template>
	<div>
		<header id="main-header" class="main-header logged-in">
			<div class="container">
				<span class="main-logo">
					<router-link
						class="desktop"
						to="/"
						@click="hidePopups"
						v-if="$route.name !== 'ThemaSingle'"
					>
						<v-Icon
							class="logo"
							alt="FPS - logo"
							name="logo-dashboard"
						/>
					</router-link>
					<router-link
						class="desktop"
						to="/"
						@click="hidePopups"
						v-else
					>
						<v-Icon
							class="logo"
							alt="FPS - logo"
							name="logo-dashboard-small"
						/>
					</router-link>
				</span>

				<nav
					id="main-nav"
					class="main-nav"
					v-if="$route.name !== 'ThemaSingle'"
				>
					<ul v-if="isAuthenticated">
						<li>
							<router-link
								class="dashboard"
								to="/"
								@click="hidePopups"
								>Dashboard</router-link
							>
						</li>
						<li>
							<router-link
								class="thema"
								to="/themes"
								@click="hidePopups"
								>Themes</router-link
							>
						</li>
						<li>
							<router-link
								class="results"
								to="/results"
								:class="{
									'router-link-active':
										$route.name === 'Results' ||
										$route.name === 'ResultsFPS' ||
										$route.name === 'ResultsTeam' ||
										$route.name === 'ResultsCustomerGroup'
								}"
								@click="hidePopups"
								>Results</router-link
							>
						</li>
						<li v-if="getCurrentUser?.level === 1">
							<router-link
								class="progress"
								to="/progress"
								@click="hidePopups"
								>Progress</router-link
							>
						</li>
						<li>
							<router-link
								class="knowledge"
								to="/knowledge/faqs"
								:class="{
									'router-link-active': checkKnowledgeRoute()
								}"
								@click="hidePopups"
								>Knowledge</router-link
							>
						</li>
					</ul>
					<!-- <ul v-else-if="!isAuthenticated">
          <li><router-link class="dashboard" to="/" @click="hidePopups">Over FPS</router-link></li>
          <li>
            <router-link class="assessments" to="/themas" @click="hidePopups"
              >Thema's</router-link
            >
          </li>
          <li>
            <router-link class="results" to="/results" @click="hidePopups"
              >Resultaten</router-link
            >
          </li>
          <li>
            <router-link class="knowledge" to="/Kennis" @click="hidePopups">Kennis</router-link>
          </li>
        </ul> -->
				</nav>

				<nav
					id="side-nav"
					class="side-nav"
					v-if="$route.name !== 'ThemaSingle'"
				>
					<ul>
						<!-- <li><router-link class="notifications" to="/meldingen">
                                <span v-if="userData" class="count">
                                    {{ userData?.newNotificationCount }}
                                </span>
                            </router-link>
                        </li>
                        <li>
                            <button class="side-toggle-btn" :class="{ 'toggle': showSideMenu }" @click="toggleSideMenu">
                                <v-Icon v-if="!showSideMenu" class="icon" name="menu" />
                                <v-Icon v-else class="icon" name="menu-close" />
                            </button>
                        </li> -->
						<li>
							<button class="logout" @click="handleLogout()">
								Logout
							</button>
						</li>
					</ul>
				</nav>
			</div>
		</header>

		<transition name="fade">
			<ForgotPasswordPopup v-if="globalStore.displayPasswordPopup" />
		</transition>
	</div>
</template>

<script>
//Vue
import { defineComponent, ref, computed, watch } from "vue"
// import { useRoute } from 'vue-router'

import { clearData } from "@streampac.io/chef_sp_1"

import { useGlobalStore } from "@/stores/global"
import { useLiveChatStore } from "@/stores/liveChat"

import { useRoute, useRouter } from "vue-router"

//Composables
import { useAuthenticationData } from "@/composables/useAuthenticationData"
import { useCurrentUserData } from "@/composables/useUserData"

//Components
// import SearchBar from '@/components/SearchBar/index.vue'
import ForgotPasswordPopup from "@/components/ForgotPasswordPopup/index.vue"

export default defineComponent({
	components: {
		ForgotPasswordPopup
	},
	setup() {
		const isAuthenticated = computed(() => {
			return useAuthenticationData().data.value.isAuthenticated
		})

		const globalStore = useGlobalStore()
		const liveChatStore = useLiveChatStore()

		const $route = useRoute()
		const $router = useRouter()

		const notificationAmount = ref(null)

		const showSideMenu = ref(false)

		const userData = ref(null)
		const showMobileMenu = ref(false)
		// const removeExtraMenu = ref(false);
		// const removeLoginBar = ref(false);

		const { getCurrentUser, getCurrentUserProfile } = useCurrentUserData()
		// const userLevel = computed(() => {

		//     if (getCurrentUser.value?.level == 2) {
		//         return 'user-hbo';
		//     } else if (getCurrentUser.value?.level == 1) {
		//         return 'user-mbo';
		//     } else {
		//         return null;
		//     }
		// });

		const newMessagesInChatAmount = ref(0)

		watch(
			() => $route.path,
			() => {
				globalStore.hideLoginPopup()
				globalStore.hidePasswordPopup()

				showSideMenu.value = false
				//showMobileMenu.value = false;

				globalStore.mobileMenuDisplayTrue()
			}
		)

		watch(
			() => isAuthenticated.value,
			() => {
				globalStore.hideLoginPopup()
				globalStore.hidePasswordPopup()

				showSideMenu.value = false
			}
		)

		watch(
			() => getCurrentUserProfile.value,
			() => {
				globalStore.setUserData(getCurrentUserProfile.value)

				userData.value = getCurrentUserProfile.value
			}
		)

		function handleLogout() {
			clearData()
			useAuthenticationData().setAuthenticated(false)

			globalStore.storeRemoveAuthenticatedStatus()
			globalStore.deleteUserSavedData()

			$router.replace({ name: "Home" })
			showSideMenu.value = false
		}

		function loginPopup() {
			globalStore.toggleLoginPopup()

			showMobileMenu.value = false
		}

		function forgotPasswordPopup() {
			globalStore.hideLoginPopup()
			globalStore.showPasswordPopup()

			showMobileMenu.value = false
		}

		function hidePopups() {
			globalStore.hideLoginPopup()
			globalStore.hidePasswordPopup()
		}

		function toggleMobileMenu() {
			showMobileMenu.value = !showMobileMenu.value
		}

		function toggleSideMenu() {
			showSideMenu.value = !showSideMenu.value
		}

		watch(
			() => liveChatStore.newMessagesInChat,
			() => {
				newMessagesInChatAmount.value = liveChatStore.newMessagesInChat
			},
			{ deep: true }
		)

		function activateChat() {
			liveChatStore.toggleDisplayChat()

			//Remove mobile menu to make room for chat.
			globalStore.toggleMobileMenuDisplay()
		}

		function checkKnowledgeRoute() {
			if (
				$route.name === "Faq" ||
				$route.name === "Blog" ||
				$route.name === "Videos" ||
				$route.name === "BlogSingle" ||
				$route.name === "VideosSingle"
			) {
				return true
			}

			return false
		}

		return {
			globalStore,
			userData,
			showMobileMenu,
			getCurrentUserProfile,
			// removeExtraMenu,
			// removeLoginBar,
			isAuthenticated,
			getCurrentUser,
			notificationAmount,
			showSideMenu,
			newMessagesInChatAmount,
			//functions
			handleLogout,
			loginPopup,
			forgotPasswordPopup,
			hidePopups,
			toggleMobileMenu,
			toggleSideMenu,
			activateChat,
			checkKnowledgeRoute
		}
	}
})
</script>

<style lang="scss" scoped>
// @import styles
@import "./index.scss";
</style>
